export function generateOnBehalfOfScope(cmid) {
    return `on_behalf_of:cm_id:${cmid}`;
}
